export default __webpack_public_path__ + "static/media/009-dragon.ca947681.svg";